/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */
import { Injectable } from '@angular/core';
import { Logger } from '@core/lib/services';
import { WorkItem } from '@app/data-model/item/work-item';
import { MessageService } from '@core/lib/services/message.service';
import { EventWorkItem } from '@app/data-model/event-work-item';

const log = new Logger('CurrentExamContextService');

@Injectable({
  providedIn: 'root'
})
export class CurrentExamContextService {
  private activeWorkItem;
  private fullContextItem;
  private previousFullContext: EventWorkItem;

  constructor(private messageService: MessageService) {}

  getFullContext() {
    return this.fullContextItem;
  }

  getPreviousFullContext() {
    return this.previousFullContext;
  }

  setContext(context: WorkItem) {
    this.previousFullContext = this.fullContextItem;
    if (context === undefined || context === null) {
      this.fullContextItem = null;
      this.activeWorkItem = undefined;
    } else {
      this.activeWorkItem = context.id;
      this.fullContextItem = context;
    }

    this.printContext(context);
    this.messageService.broadcast('currentExamContext.changed');
    return true;
  }

  resetContext(context) {
    if (this.activeWorkItem === context.id) {
      this.setContext(undefined);
    }
  }

  // May consider removing this ..  used for insight into context.
  printContext(callerFunction) {
    if (this.getFullContext() !== null && this.getFullContext() !== undefined) {
      log.debug('Full Context is not null ' + callerFunction);
      if (this.getFullContext().keys !== null) {
        log.debug('Context Keys NOT null, RPR: ' + this.getFullContext().id);
        const acc = this.getFullContext().keys?.procedureAccessionNo;
        if (acc !== null) {
          log.debug('Full Context - Accession is valid: ACC: ' + acc);
        } else {
          log.debug('Full Context -  Accession is null or undefined');
        }
      }
    } else {
      log.debug(callerFunction + ' Full Context is null or undefined');
    }
  }

  clearContext(lifecycle, targets) {
    if (this.activeWorkItem === targets.id) {
      this.setContext(undefined);
    }
    if (lifecycle) {
      lifecycle.done();
    }
  }

  getContext() {
    return this.activeWorkItem;
  }
}
